export const geoLocationIds = [
  {
    GeoLocationID: 1800,
    Title: 'تهران',
    SortOrder: 1,
    ParentID: 171,
    Parent: 'ایران',
    Coordinates: '35.70314306909481,51.39092522779538',
    Type: 'State'
  },
  {
    GeoLocationID: 4519,
    Title: 'منطقه 1',
    SortOrder: 1,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.803494,51.45721209999999',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4541,
    Title: 'پارک علم و فناوری',
    SortOrder: 1,
    ParentID: 4540,
    Parent: 'ایران, تهران, پردیس',
    Coordinates: '35.72989637621322,51.824870109558105',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4542,
    Title: 'فاز 1 پردیس',
    SortOrder: 1,
    ParentID: 4540,
    Parent: 'ایران, تهران, پردیس',
    Coordinates: '35.74501805860091,51.81749779289248',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4520,
    Title: 'منطقه 2',
    SortOrder: 2,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.7424758,51.35750280000002',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4543,
    Title: 'فاز 2 پردیس',
    SortOrder: 2,
    ParentID: 4540,
    Parent: 'ایران, تهران, پردیس',
    Coordinates: '35.74836177942696,51.802219930343654',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4521,
    Title: 'منطقه 3',
    SortOrder: 3,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.7545127,51.44822720000002',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4544,
    Title: 'فاز 3 پردیس',
    SortOrder: 3,
    ParentID: 4540,
    Parent: 'ایران, تهران, پردیس',
    Coordinates: '35.746411292681614,51.833891454391505',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4522,
    Title: 'منطقه 4',
    SortOrder: 4,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.75007960000001,51.5255214',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4545,
    Title: 'فاز 4 پردیس',
    SortOrder: 4,
    ParentID: 4540,
    Parent: 'ایران, تهران, پردیس',
    Coordinates: '35.74397311703767,51.8471263481174',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4523,
    Title: 'منطقه 5',
    SortOrder: 5,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.7451824,51.3155653',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4546,
    Title: 'فاز 5 پردیس',
    SortOrder: 5,
    ParentID: 4540,
    Parent: 'ایران, تهران, پردیس',
    Coordinates: '35.75198398514589,51.78625542228701',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4524,
    Title: 'منطقه 6',
    SortOrder: 6,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.7211186,51.399467200000004',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4525,
    Title: 'منطقه 7',
    SortOrder: 7,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.7183611,51.44145849999995',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4526,
    Title: 'منطقه 8',
    SortOrder: 8,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.7222252,51.48873070000002',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4527,
    Title: 'منطقه 9',
    SortOrder: 9,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.6866604,51.32080599999995',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4547,
    Title: 'فاز 9 پردیس',
    SortOrder: 9,
    ParentID: 4540,
    Parent: 'ایران, تهران, پردیس',
    Coordinates: '35.75088906164848,51.770397171907575',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4528,
    Title: 'منطقه 10',
    SortOrder: 10,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.6839277,51.36274690000005',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4529,
    Title: 'منطقه 11',
    SortOrder: 11,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.6772042,51.39422020000006',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4548,
    Title: 'فاز 11 پردیس',
    SortOrder: 11,
    ParentID: 4540,
    Parent: 'ایران, تهران, پردیس',
    Coordinates: '35.769256252161476,51.78080262428068',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4530,
    Title: 'منطقه 12',
    SortOrder: 12,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.68065539796162,51.43091863801135',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4531,
    Title: 'منطقه 13',
    SortOrder: 13,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.70754049999999,51.4992403',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4532,
    Title: 'منطقه 14',
    SortOrder: 14,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.678282,51.48347660000002',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4533,
    Title: 'منطقه 15',
    SortOrder: 15,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.6434226,51.467936099999974',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4534,
    Title: 'منطقه 16',
    SortOrder: 16,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.640696363893525,51.414964907776266',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4535,
    Title: 'منطقه 17',
    SortOrder: 17,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.65757845428332,51.3624992165461',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4536,
    Title: 'منطقه 18',
    SortOrder: 18,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.65207249999999,51.3155653',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4549,
    Title: 'منطقه 19',
    SortOrder: 19,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.62599239151888,51.36520255940536',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4537,
    Title: 'منطقه 20',
    SortOrder: 20,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.5700109,51.469162900000015',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4538,
    Title: 'منطقه 21',
    SortOrder: 21,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.69184879678673,51.26127912229276',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4539,
    Title: 'منطقه 22',
    SortOrder: 22,
    ParentID: 4131,
    Parent: 'ایران, تهران, تهران',
    Coordinates: '35.7563748,51.20466699999997',
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4131,
    Title: 'تهران',
    SortOrder: 102,
    ParentID: 1800,
    Parent: 'ایران, تهران',
    Coordinates: '35.6961,51.4231',
    Type: 'City'
  },
  {
    GeoLocationID: 4540,
    Title: 'پردیس',
    SortOrder: 103,
    ParentID: 1800,
    Parent: 'ایران, تهران',
    Coordinates: '35.74418964124986,51.784816496064195',
    Type: 'City'
  },
  {
    GeoLocationID: 4135,
    Title: 'رودهن',
    SortOrder: 106,
    ParentID: 1800,
    Parent: 'ایران, تهران',
    Coordinates: '35.73505493193967,51.91178868255611',
    Type: 'City'
  },
  {
    GeoLocationID: 4127,
    Title: 'بومهن',
    SortOrder: 110,
    ParentID: 1800,
    Parent: 'ایران, تهران',
    Coordinates: '35.73185079255057,51.86797696655276',
    Type: 'City'
  },
  {
    GeoLocationID: 4550,
    Title: 'شهر رودهن',
    SortOrder: 1000,
    ParentID: 4135,
    Parent: 'ایران, تهران, رودهن',
    Coordinates: null,
    Type: 'CityZone'
  },
  {
    GeoLocationID: 4551,
    Title: 'شهر بومهن',
    SortOrder: 1000,
    ParentID: 4127,
    Parent: 'ایران, تهران, بومهن',
    Coordinates: '35.7321294874018,51.86865282117117',
    Type: 'CityZone'
  }
]
